import { Select, SelectProps } from "@mui/material";
import React, { JSX } from "react";

export type DefaultSelectProps<T = unknown> = SelectProps<T>;

export default function DefaultSelect<T = unknown>({
    children,
    ...rest
}: DefaultSelectProps<T>): JSX.Element {
    type KeyDownCapableProps = {
        onKeyDown?: (event: React.KeyboardEvent) => void;
    };

    function onKeyDown(event: React.KeyboardEvent) {
        if (event.key === " ") {
            event.preventDefault();
        }
    }

    return (
        <Select {...rest}>
            {React.Children.map(children, (child) => {
                if (!React.isValidElement<KeyDownCapableProps>(child)) {
                    return null;
                }

                return React.cloneElement(child, {
                    onKeyDown: onKeyDown
                })
            })}
        </Select>
    );
}
